import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { BrandProvider } from '@proaxiv/brands'
import { store } from './store'
import { ErrorBoundary } from './components/ErrorBoundary'
import { AuthProvider } from './auth/AuthProvider'
import { ActiveOrgProvider } from './contexts/ActiveOrgContext'
import './i18n/index.ts'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter basename="/">
          <BrandProvider>
            <AuthProvider>
              <ActiveOrgProvider>
                <Suspense fallback={null}>
                  <ErrorBoundary>
                    <App />
                  </ErrorBoundary>
                </Suspense>
              </ActiveOrgProvider>
            </AuthProvider>
          </BrandProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </StrictMode>
)
